import { Injectable } from '@angular/core';
import { FondsEvenementiel } from '@lib/models/generated/graphql';
import { gql } from 'apollo-angular';
import { QueryManagerService } from 'finzzle-angular-utils';
import _ from 'lodash';
import { lastValueFrom } from 'rxjs';

export const FONDS_EVENEMENTIELS_BY_PRODUIT = gql`
  query fondsEvenementielsByProduit($produitId: Long!) {
    fondsEvenementielsByProduit(produitId: $produitId) {
      id
      code
      libelle
      ordre
      modeDeGestionCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FondsEvenementielService {
  private fonds: FondsEvenementiel[] = [];

  constructor(private queryManager: QueryManagerService) {}

  reset() {
    this.fonds = [];
  }

  async loadFondsEvenementielsByProduit(produitId: number | null): Promise<void> {
    if (produitId === null || isNaN(produitId)) {
      this.fonds = [];
      return;
    }
    const { data } = await lastValueFrom(
      this.queryManager.query<{ fondsEvenementielsByProduit: FondsEvenementiel[] }>({
        query: FONDS_EVENEMENTIELS_BY_PRODUIT,
        variables: { produitId },
      })
    );

    this.fonds = data?.fondsEvenementielsByProduit ?? [];
  }

  public get fondsEvenementiels(): FondsEvenementiel[] {
    return this.fonds;
  }

  public get fondsEvenementielsByModeGestionCode(): Record<string, FondsEvenementiel[]> {
    return _.groupBy(this.fonds, 'modeDeGestionCode');
  }

  public getFondsEvenementielsByModeGestion(gestionCode: string): FondsEvenementiel[] {
    return this.fondsEvenementielsByModeGestionCode[gestionCode] ?? [];
  }
}
